"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react")); // tslint:disable-next-line:variable-name


var Toast = function Toast(props) {
  return react_1.default.createElement("div", {
    className: classnames_1.default('emankit__toast', props.className, props.visible ? 'show' : undefined)
  }, props.children);
};

exports.default = Toast;